import React, {useEffect, useState} from 'react'
import millify from 'millify'
import { Link } from 'react-router-dom'
import {  Card, Row, Col, Input, Typography } from 'antd'
import Loader from './Loader'
import { useGetCryptosQuery } from '../services/cryptoApi'


const Cryptocurrencies = ({simplified}) => {
    const count = simplified ? 10 :100;
    const {data: cryptoList, isFetching} = useGetCryptosQuery(count);
    const [cryptos, setCryptos] =useState([]);
    const [searchTerm, setSearchTerm] =useState('');
    console.log(cryptos);
    const {Title} = Typography;

    useEffect(() => {
        const filteredData = cryptoList?.data?.coins.filter((coin) => coin.name.toLowerCase().includes(searchTerm.toLowerCase()));

        setCryptos(filteredData);

    }, [cryptoList, searchTerm])


    if(isFetching) return <Loader/>;
    return (
        <>
        
        {!simplified && (
            <div>
                <Title level={2}>Top 100 Cryptocurrencies</Title>
            <div className="search-crypto">
                 
            <Input placeholder="Search-CryptoCurrency" onChange={(e) => setSearchTerm(e.target.value)}/>
        </div>
        </div>
        )}

        <Row gutter={[32,32]} className="crypto-card-container">
            {cryptos?.map((currency) =>(
                <Col xs={24} sm={12} lg={6} className="crypto-card" key={currency.id}>
                    <Link to={`/crypto/${currency.id}`}>
                        <Card 
                            title={`${currency.rank}.${currency.name}`}
                            extra={<img className="crypto-image" src={currency.iconUrl} alt='' />}
                            hoverable
                        >
                            <p>Price: $ {millify(currency.price)}</p>
                            <p>Market Cap: {millify(currency.marketCap)}</p>
                            <p>Daily Change: {millify(currency.change)}%</p>
                        </Card>
                    </Link>
                </Col>
            ))}
        </Row>
        </>
    )
}

export default Cryptocurrencies
